import React from "react";
import { Helmet } from "react-helmet";
import CanonicalTag from "./CanonicalTag";
import "../index.css";
import plaster from "../assets/Images/plaster.avif";
import mkub from "../assets/Images/mkub.jpg";
import rmc from "../assets/Images/RMC-1.png";

const Cement = () => {
  return (
    <>
      <Helmet>
        <title>
          Cement Products Manufacturer & Supplier | OPC & PPC Cement | Valerion
          Impex
        </title>

        <meta
          name="description"
          content="Valerion Impex supplies premium cement products including OPC cement, PPC cement and construction cement for residential, commercial and industrial projects worldwide."
        />

        <meta
          name="keywords"
          content="cement products, OPC cement, PPC cement, Portland cement, ordinary Portland cement, Portland pozzolana cement, construction cement, cement supplier, cement manufacturer, bulk cement supplier, building materials, industrial cement, grey cement, cement exporter, cement distributor, cement company India, cement for construction, high strength cement, Valerion Impex"
        />
      </Helmet>

      {/* Canonical URL */}
      <CanonicalTag url="https://www.cementmachineryparts.in/cement" />

      <div className="container-fluid p-0 position-relative">
        <div className="row g-0 mb-3 position-relative">
          <div className="col-md-6 position-relative">
            <img
              src={plaster}
              alt="Plastering"
              className="img-fluid w-100 h-100 object-fit-cover"
            />
            <div className="overlay-text text-white">
              <h1 className="fw-bold text-center">Cement</h1>
              <p>
                Whether in bags or in bulk, we provide our customers with
                high-quality cement products and services. Our knowledge and
                experience allow us to develop customized products that are both
                sustainable and meet our client's unique construction needs.
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <img
              src={mkub}
              alt="Cement Truck"
              className="img-fluid w-100 h-100 object-fit-cover"
            />
          </div>
        </div>
      </div>

      <div className="container my-4">
        <div className="row justify-content-center g-4">
          <div className="col-md-4">
            <div className="cement-card text-white p-5">
              <h4 className="text-warning fw-bold text-center">OPC Cement</h4>
              <p>
                These applications cover ordinary, standard, high strength
                concretes, masonry and plastering works, precast concrete
                products for e.g., blocks, pipes etc., and specialized works
                such as precast and prestressed concrete.
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="cement-card text-white p-5">
              <h4 className="text-warning fw-bold text-center">PPC Cement</h4>
              <p>
                Construction of hydraulic structures, marine works, mass
                concreting such as dams, dykes, retaining walls foundations and
                sewage pipes. It is also suitable for use in common applications
                such as masonry mortars and plastering.
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <img src={rmc} alt="Ready Mix Cement" className="img-fluid rmc" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Cement;
